import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { getParams } from '@Services/common/services-utils';
import { environment } from '@Env/environment';
import { Page } from './page.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class PageService {
  private url = `${environment.baseUrl}/api_bdc/pages/`;

  constructor(private http: HttpClient) {
  }

  private _checkBody(data) {
    if (!('body' in data.content)) {
      data.content['body'] = [];
    }

    return data;
  }

  get(id: number): Observable<Page> {
    return this.http.get<Page>(`${this.url}${id}/`).pipe(
      map(data => {
        return this._checkBody(data);
      }));
  }

  getBySlug(slug: string): Observable<Page> {
    const url = `${this.url}${slug}/get_by_slug/`;
    return this.http.get<Page>(url).pipe(
      map(data => {
        // console.log('data slug ', data);
        if (data && 'id' in data) {
          return this._checkBody(data);
        }

        return of(<Page>{});
      }));
  }

  list(
    offset: number = 0,
    limit: number = 0,
    keyword: string = '',
    title: string = null,
    by_parent: number = null,
    by_parent_path: string = null,
    show_content: boolean = false,
    ordering: string = '',
  ) {
    const params = getParams(limit, offset, keyword, ordering, {
      'title': title,
      'by_parent': by_parent,
      'by_parent_path': by_parent_path,
      'show_content': show_content
    });

    return this.http.get<Page[]>(this.url, {params});
  }

  listAll(extraParams: Map<string, string> = null, keyword: string = ''): Observable<Page[]> {
    const extra = {};
    if (extraParams !== null) {
      extraParams.forEach((v, k) => {
        extra[k] = v;
      });
    }

    const params = getParams(0, 0, keyword, '', extra);

    return this.http.get<Page[]>(this.url, {params: params});
  }

  update(page: Page) {
    return this.http.put<Page>(`${this.url}${page.id}/`, page);
  }

  create(page: Page) {
    return this.http.post<Page>(this.url, page);
  }

  updateOrCreate(page: Page) {
    console.log(page);
    return ('id' in page && page.id) ? this.update(page) : this.create(page);
  }

  delete(page: Page) {
    return this.http.delete<Page>(`${this.url}${page.id}/`);
  }

  getParent(id: number) {
    return this.http.get<Page>(`${this.url}${id}/get_parent/`);
  }

  search(keyword: string = '', forAdmin = false) {
    const url = `${this.url}`;
    const params = getParams(0, 0, keyword, '', {
      'show_content': false,
      'for_admin': forAdmin
    });

    return this.http.get<Page[]>(url, {params});
  }

  canEdit(id: number): Observable<any> {
    const url = `${this.url}${id}/can_edit/`;
    return this.http.get<any>(url);
  }

  savePageOrder(orderedPage: any) {
    const params = {
    'page_order' : orderedPage,
    };
    return this.http.post<any>(`${this.url}save_page_order/`, params);
  }

}
